(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('.gallery__slide'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-thumb]'));
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('[data-gallery-counter]');
      this.current = 0;
      this.ticking = false;

      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      this.thumbs.forEach(
        function (thumb) {
          thumb.addEventListener(
            'click',
            function () {
              this.goTo(parseInt(thumb.getAttribute('data-gallery-thumb'), 10));
            }.bind(this)
          );
        }.bind(this)
      );
      if (this.prev) this.prev.addEventListener('click', this.step.bind(this, -1));
      if (this.next) this.next.addEventListener('click', this.step.bind(this, 1));
      var zoom = this.querySelector('[data-gallery-zoom]');
      var lightbox = this.querySelector('[data-lightbox]');
      if (zoom && lightbox) {
        zoom.addEventListener(
          'click',
          function () {
            var slide = this.slides[this.current];
            var src = slide && slide.getAttribute('data-zoom-src');
            if (!src) return;
            var img = lightbox.querySelector('[data-lightbox-img]');
            img.src = src;
            img.alt = slide.getAttribute('data-zoom-alt') || '';
            if (window.byju && window.byju.drawer) window.byju.drawer.open(lightbox, zoom);
          }.bind(this)
        );
      }
      window.addEventListener('resize', this.onResize.bind(this));

      var featured = this.getAttribute('data-featured-media');
      if (featured) this.goToMedia(featured, false);
    }

    onResize() {
      this.goTo(this.current, false);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(
        function () {
          this.ticking = false;
          var width = this.track.clientWidth || 1;
          this.setCurrent(Math.round(this.track.scrollLeft / width));
        }.bind(this)
      );
    }

    setCurrent(index) {
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.current = index;
      this.thumbs.forEach(function (thumb, i) {
        if (i === index) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (this.prev) this.prev.disabled = index === 0;
      if (this.next) this.next.disabled = index === this.slides.length - 1;
      if (this.counter) {
        this.counter.textContent = this.counter.getAttribute('data-template').replace('__INDEX__', String(index + 1));
      }
    }

    step(direction) {
      this.goTo(this.current + direction, true);
    }

    goTo(index, smooth) {
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      var behavior = smooth === false || reducedMotion.matches ? 'auto' : 'smooth';
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: behavior });
      this.setCurrent(index);
    }

    goToMedia(mediaId, smooth) {
      if (!mediaId) return;
      for (var i = 0; i < this.slides.length; i++) {
        if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) {
          if (i !== this.current) this.goTo(i, smooth);
          return;
        }
      }
    }
  }

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      var data = this.querySelector('[data-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.form = this.closest('form');
      this.groups = Array.prototype.slice.call(this.querySelectorAll('.variant-picker__group'));
      this.sectionId = this.getAttribute('data-section-id');
      this.baseUrl = this.getAttribute('data-url');
      this.requestId = 0;

      var hidden = this.form && this.form.querySelector('[data-variant-id]');
      if (hidden) hidden.name = 'id';

      this.addEventListener('change', this.onChange.bind(this));

      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.updateAvailability();
    }

    onSubmit(event) {
      var missing = this.groups.filter(function (group) {
        return !group.querySelector('input:checked');
      });
      if (!missing.length) return;
      event.preventDefault();
      missing.forEach(function (group) {
        group.classList.add('is-invalid');
        var error = group.querySelector('[data-option-error]');
        if (error) {
          error.hidden = false;
          error.setAttribute('role', 'alert');
        }
      });
      var first = missing[0];
      var input = first.querySelector('input');
      first.scrollIntoView({ block: 'center', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      if (input) input.focus({ preventScroll: true });
    }

    clearErrors() {
      this.groups.forEach(function (group) {
        if (!group.querySelector('input:checked')) return;
        group.classList.remove('is-invalid');
        var error = group.querySelector('[data-option-error]');
        if (error) {
          error.hidden = true;
          error.removeAttribute('role');
        }
      });
    }

    selectedOptions() {
      return this.groups.map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    findVariant(options) {
      return (
        this.variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === options[index];
          });
        }) || null
      );
    }

    isAvailable(options) {
      return this.variants.some(function (variant) {
        return (
          variant.available &&
          variant.options.every(function (value, index) {
            return options[index] === null || value === options[index];
          })
        );
      });
    }

    updateAvailability() {
      var selected = this.selectedOptions();
      this.groups.forEach(
        function (group, groupIndex) {
          Array.prototype.forEach.call(
            group.querySelectorAll('input'),
            function (input) {
              var candidate = selected.slice();
              candidate[groupIndex] = input.value;
              if (!this.isAvailable(candidate)) {
                input.setAttribute('data-sold-out', 'true');
              } else {
                input.removeAttribute('data-sold-out');
              }
            }.bind(this)
          );
        }.bind(this)
      );
    }

    onChange() {
      this.clearErrors();
      var options = this.selectedOptions();
      this.groups.forEach(function (group, index) {
        var label = group.querySelector('[data-selected-label]');
        if (label) label.textContent = options[index] || '';
      });
      this.updateAvailability();

      var variant = this.findVariant(options);
      var hidden = this.form.querySelector('[data-variant-id]');
      var button = this.form.querySelector('[data-add-button]');

      if (!variant) {
        if (hidden) hidden.value = '';

        if (options.indexOf(null) > -1) return;
        this.form.querySelectorAll('[data-add-button]').forEach(function (btn) {
          btn.disabled = true;
        });
        if (button) {
          var label = button.querySelector('[data-add-label]');
          if (label) label.textContent = this.getAttribute('data-unavailable-text') || '';
        }
        return;
      }

      if (hidden) hidden.value = variant.id;

      var gallery = document.querySelector('product-gallery');
      if (gallery && variant.featured_media) gallery.goToMedia(variant.featured_media.id, true);

      this.refresh(variant.id);
    }

    refresh(variantId) {
      var requestId = ++this.requestId;
      var buy = this.form.querySelector('[data-product-buy]');
      if (buy) buy.setAttribute('aria-busy', 'true');

      fetch(this.baseUrl + '?variant=' + variantId + '&section_id=' + this.sectionId)
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(
          function (html) {
            if (requestId !== this.requestId) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');

            var currentQty = document.querySelector('[data-product-buy] .qty__input');
            var qtyValue = currentQty ? currentQty.value : null;
            ['[data-product-price]', '[data-product-buy]'].forEach(function (selector) {
              var fresh = doc.querySelector(selector);
              var current = document.querySelector(selector);
              if (fresh && current) current.replaceWith(fresh);
            });
            var freshQty = document.querySelector('[data-product-buy] .qty__input');
            if (freshQty && qtyValue) {
              var max = freshQty.max ? parseInt(freshQty.max, 10) : null;
              var value = Math.max(parseInt(freshQty.min, 10) || 1, parseInt(qtyValue, 10) || 1);
              if (max) value = Math.min(value, max);
              freshQty.value = value;
              var wrap = freshQty.closest('[data-quantity]');
              var minus = wrap && wrap.querySelector('[data-qty-minus]');
              var plus = wrap && wrap.querySelector('[data-qty-plus]');
              if (minus) minus.disabled = value <= (parseInt(freshQty.min, 10) || 1);
              if (plus) plus.disabled = !!max && value >= max;
            }
            if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
            if (window.byju && window.byju.showJsOnly) window.byju.showJsOnly();
            if (window.byju && window.byju.wishlist) window.byju.wishlist.sync();
          }.bind(this)
        )
        .catch(function () {
          var current = document.querySelector('[data-product-buy]');
          if (current) current.removeAttribute('aria-busy');
        });
    }
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var url = this.getAttribute('data-url');
      if (!url) return;
      if (!('IntersectionObserver' in window)) {
        this.load(url);
        return;
      }
      this.observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            this.observer.disconnect();
            this.load(url);
          }
        }.bind(this),
        { rootMargin: '300px 0px' }
      );
      this.observer.observe(this);
    }

    load(url) {
      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(
          function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.querySelector('.card')) {
              this.replaceChildren.apply(this, Array.prototype.slice.call(fresh.childNodes));
              this.removeAttribute('data-empty');
              if (window.byju && window.byju.observeReveal) window.byju.observeReveal(this);
              if (window.byju && window.byju.wishlist) window.byju.wishlist.sync();
              if (window.byju && window.byju.initCarousels) window.byju.initCarousels(this);
            }
          }.bind(this)
        )
        .catch(function () {});
    }
  }

  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;
      this.classList.add('is-ready');
      this.initScroller();
      this.querySelectorAll('[data-panel-hidden]').forEach(function (panel) {
        panel.hidden = true;
      });
      this.tabs.forEach(
        function (tab, index) {
          tab.addEventListener('click', this.select.bind(this, index, false));
          tab.addEventListener(
            'keydown',
            function (event) {
              var next = null;
              if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
              if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = this.tabs.length - 1;
              if (next !== null) {
                event.preventDefault();
                this.select(next, true);
              }
            }.bind(this)
          );
        }.bind(this)
      );
    }

    initScroller() {
      var list = this.querySelector('.tabs__list');
      if (!list || list.parentNode.classList.contains('tabs__scroller')) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var wrap = document.createElement('div');
      wrap.className = 'tabs__scroller';
      list.parentNode.insertBefore(wrap, list);
      wrap.appendChild(list);

      var make = function (side, label) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'tabs__arrow tabs__arrow--' + side;
        button.hidden = true;
        if (label) button.setAttribute('aria-label', label);
        button.addEventListener('click', function () {
          var step = list.clientWidth * 0.6 * (side === 'next' ? 1 : -1);
          list.scrollBy({ left: step, behavior: reduced.matches ? 'auto' : 'smooth' });
        });
        return button;
      };
      var prev = make('prev', this.getAttribute('data-prev-label'));
      var next = make('next', this.getAttribute('data-next-label'));
      wrap.insertBefore(prev, list);
      wrap.appendChild(next);

      var update = function () {
        var max = list.scrollWidth - list.clientWidth - 2;
        prev.hidden = max <= 0 || list.scrollLeft <= 2;
        next.hidden = max <= 0 || list.scrollLeft >= max;
      };
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (window.ResizeObserver) new ResizeObserver(update).observe(list);
      update();
    }

    select(index, focus) {
      this.tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) this.tabs[index].focus();
    }
  }

  if (!customElements.get('product-tabs')) customElements.define('product-tabs', ProductTabs);
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  function initShare() {
    document.querySelectorAll('[data-share]').forEach(function (button) {
      if (navigator.share || (navigator.clipboard && navigator.clipboard.writeText)) {
        button.hidden = false;
      }
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('[data-share]');
    if (!button) return;
    var url = button.getAttribute('data-share-url');
    var title = button.getAttribute('data-share-title');
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        if (window.byju && window.byju.toast) window.byju.toast(button.getAttribute('data-copied-message'));
      });
    }
  });

  initShare();
})();
